<style scoped>
    .text-remark {
        margin: 0px;
    }
    .hover-style {
        cursor: pointer;
    }
</style>
<template>
  <span
    class="text-center"
    style="display:inline"
  >
    <v-tooltip top>
      <template v-slot:activator="{ on, attrs }">
        <v-icon
          class="hover-style"
          size="20"
          color="primary"
          v-bind="attrs"
          v-on="on"
        >
          mdi-help-circle-outline
        </v-icon>
      </template>
      <p class="text-remark">
        如果是已完成付款再提交单据审批流程，请选择“是”。
      </p>
    </v-tooltip>
  </span>
</template>
<script>
  export default {

  }
</script>
